module.exports = __webpack_public_path__ + "img/thumbnail_EurasianLynx_f_albino.cce88e49.png";